import { createSlice } from "@reduxjs/toolkit";

export interface ReduxStateShowDemo {
  showDemoOnLogin: boolean;
}

const initialState: ReduxStateShowDemo = {
  showDemoOnLogin: true,
};

export const showDemoSlice = createSlice({
  name: "showDemo",
  initialState,
  reducers: {
    SetShowDemo: (state, action) => {
      state.showDemoOnLogin = action.payload;
      console.debug("demo:SetShowDemo(" + action.payload + ") ok");
    },
  },
});

export const { SetShowDemo } = showDemoSlice.actions;

export const IsShowDemo = (state): boolean => state.showDemoSlice.showDemoOnLogin;

export default showDemoSlice.reducer;
